import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { RadioGroup } from "@cayuse/shared-react.components.form.radio-group";
import { useDictionary } from "hooks";
import { useRuleBuilderContext } from "containers/Rules/context/useRuleBuilderContext";

import styles from "./styles.css";

const getOperators = (dictionary) => {
    return [
        {
            label: dictionary.andLabel || "AND",
            value: "AND",
        },
        {
            label: dictionary.orLabel || "OR",
            value: "OR",
        },
    ];
};

const AndOrComponent = ({ operand, index, isEditing, className = "" }) => {
    const dictionary = useDictionary("ruleBuilder.conditionBuilder");
    const { setFormChanged } = useRuleBuilderContext();
    const [operator, setOperator] = useState();

    const changeSelection = (value) => {
        operand.operator = value;
        setOperator(value);
        setFormChanged(true);
    };

    useEffect(() => {
        setOperator(operand.operator);
    }, [operand.operator]);

    if (index === 0 || !operator) {
        return null;
    }

    if (isEditing) {
        return (
            <div className={`${styles.radioGroup} ${className}`}>
                <RadioGroup
                    className={styles.radioGroup}
                    value={operator}
                    onChange={changeSelection}
                    options={getOperators(dictionary)}
                />
            </div>
        );
    }

    return <div className={styles.operator}>{operator}</div>;
};

AndOrComponent.propTypes = {
    operand: PropTypes.string,
    index: PropTypes.number,
    isEditing: PropTypes.bool,
    className: PropTypes.string,
};

export default AndOrComponent;
